import { Controller } from "stimulus"
import Splide from "@splidejs/splide"

export default class extends Controller {
  static targets = ["main", "thumbnails"]

  connect() {
    this.mainSplide = new Splide(this.mainTarget, {
      type: "fade",
      heightRatio: 0.6,
      pagination: false,
      arrows: false,
      cover: false,
    })

    if (this.hasThumbnailsTarget) {
      this.thumbnailsSplide = new Splide(this.thumbnailsTarget, {
        rewind: true,
        fixedWidth: 104,
        fixedHeight: 58,
        isNavigation: true,
        gap: 10,
        focus: "center",
        pagination: false,
        cover: true,
        dragMinThreshold: {
          mouse: 4,
          touch: 10,
        },
        breakpoints: {
          640: {
            fixedWidth: 66,
            fixedHeight: 38,
          },
        },
      })

      this.mainSplide.sync(this.thumbnailsSplide)
      this.mainSplide.mount()
      this.thumbnailsSplide.mount()
    } else {
      this.mainSplide.mount()
    }
  }

  disconnect() {
    this.mainSplide?.destroy()
    this.thumbnailsSplide?.destroy()
  }
}
